import { useAppSelector } from "@js/hooks/redux";

export const useFreelancerProfile = () => {
  return useAppSelector((state) => state.freelancer.freelancerProfile);
};
